export default "__VITE_ASSET__I93pqoIK__"